
// src/connects/user-logout-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import savedTempSearchQuery from '../actions/save-search-query-temp'

export const mapStateToProps = (state)=> {
  return {
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    logout: (allLogout)=> {
      dispatch(actions.logout(allLogout))
      dispatch(actions.closeUserSettingsPage())
      //検索条件の保持をログアウトした時にクリアする
      savedTempSearchQuery.clear()
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({
    state: {
      allLogout: false 
    }
  }),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/user-logout-panel.js